import { Controller } from "@hotwired/stimulus"

// Generic tabbed UI: shows one panel at a time and remembers the active tab in a
// cookie. Tabs and their panels are matched by a `data-tab-key` attribute.
//
// Markup contract (see V2::TabsComponent):
//   data-controller="tabs" data-tabs-cookie-name-value="..."
//   <button data-tabs-target="tab" data-tab-key="x" data-action="click->tabs#select">
//   <div    data-tabs-target="panel" data-tab-key="x">
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeKey: String,
    cookieName: { type: String, default: "v2_active_tab" }
  }

  connect() {
    if (!this.activeKeyValue) {
      const saved = this.getSavedTab()
      const validKeys = this.tabTargets.map(t => t.dataset.tabKey)
      this.activeKeyValue = (saved && validKeys.includes(saved)) ? saved : validKeys[0]
    }
    this.updateTabs()
  }

  select(event) {
    event.preventDefault()
    const key = event.currentTarget.dataset.tabKey
    if (key === this.activeKeyValue) return

    this.activeKeyValue = key
    this.saveTab(key)
    this.updateTabs()
  }

  updateTabs() {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tabKey === this.activeKeyValue)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabKey !== this.activeKeyValue)
    })
  }

  getSavedTab() {
    const name = this.cookieNameValue
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : null
  }

  saveTab(key) {
    const name = this.cookieNameValue
    document.cookie = `${name}=${encodeURIComponent(key)}; path=/; max-age=${60 * 60 * 24 * 365}`
  }
}
